import React from "react";
import { IMAGES } from "../lib/content";

/**
 * Renders the official eagle artwork as a premium, subtle background.
 * Heavy dark overlay (≈80%) keeps text readable; slow zoom adds calm motion.
 * position: "top" | "center" | "right"
 */
const POSITION_MAP = {
  center: "center 30%",
  right: "right center",
  top: "center top",
};

export default function EagleBackdrop({ position = "top", opacity = 0.9, fadeBottom = true }) {
  const objectPosition = POSITION_MAP[position] || POSITION_MAP.top;
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <img
        src={IMAGES.eagle}
        alt=""
        className="eagle-zoom h-full w-full object-cover"
        style={{ objectPosition, opacity }}
        loading="eager"
      />
      {/* Dark overlay 80% + edge vignette so the eagle emerges from shadow */}
      <div className="absolute inset-0 bg-[#050505]/80" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,transparent_0%,rgba(5,5,5,0.4)_55%,#050505_100%)]" />
      {fadeBottom && <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#050505] to-transparent" />}
    </div>
  );
}
